import {
  MembershipType,
  useMembership,
} from '~/techstyle-shared/react-accounts';

/**
 * @description Custom hook to determine if the current user is an EMP member.
 *
 * This hook utilizes the `useMembership` hook to retrieve the user's membership type
 * and checks if it matches the EMP membership types (`MembershipType.TOKEN` or
 * `MembershipType.TOKEN_ANNIVERSARY`).
 *
 * @returns {Object} An object containing:
 * - `isEmpMembership` {boolean} - A boolean indicating whether the user is an EMP member.
 */
export default function useIsEmpMembership() {
  const { membershipTypeId } = useMembership();
  const isEmpMembership =
    membershipTypeId === MembershipType.TOKEN ||
    membershipTypeId === MembershipType.TOKEN_ANNIVERSARY;

  return {
    isEmpMembership,
  };
}
